import SeoHead from './SeoHead';

interface VendorHeadProps {
  title?: string;
  description?: string;
  imageUrl?: string;
  canonicalUrl?: string;
  noindex?: boolean;
}

const VendorHead = ({
  title = 'Find Wedding Vendors - Zola',
  description = "Explore highly-rated wedding vendors from enchanting florists to lively bands, DJs, and exquisite caterers – find your wedding dream team with Zola's vendor search.",
  imageUrl,
  canonicalUrl,
  noindex = false,
}: VendorHeadProps) => (
  <SeoHead
    title={title}
    description={description}
    imageUrl={imageUrl}
    canonicalUrl={canonicalUrl}
    noindex={noindex}
  />
);

export default VendorHead;
